import { useState, useRef, useEffect } from "react";
import { FaRegAddressCard } from "react-icons/fa";
import { GiBank } from "react-icons/gi";
import { IoMdPerson } from "react-icons/io";
import { IoDocumentTextOutline, IoPricetagsOutline } from "react-icons/io5";
import { MdAccountBalance, MdAttachMoney, MdSettings } from "react-icons/md";
import { RiContactsFill } from "react-icons/ri";
import doxzonLogo from "../../assets/logo/Doxzon_Logo_White_background.svg";
import { Select as AntdSelect, message, Modal, TimePicker } from "antd";
import { LiaSignatureSolid, LiaStampSolid } from "react-icons/lia";
import dayjs from "dayjs";
import CommonService from "../../Services/CommonService";
import UserService from "../../Services/UserService";
import enrollmentServices from "../../Services/enrollmentServices";
const { Option } = AntdSelect;
const { RangePicker } = TimePicker;
// ─── Data Constants ───────────────────────────────────────────────────────────

export const qualificationList = {
    doctor: [
        "MBBS",
        "MBBS, MD (General Medicine)",
        "MBBS, MD (Family Medicine)",
        "MBBS, MD",
        "MBBS, MS (General Surgery)",
        "MBBS, MS (Orthopaedics)",
        "MBBS, MS, MCh (Neurosurgery)",
        "MBBS, MS, MCh (Plastic Surgery)",
        "MBBS, MS, MCh (Cardiothoracic Surgery)",
        "MBBS, MS, MCh (Urology)",
        "MBBS, MD (Paediatrics)",
        "MBBS, MS/MD (Obstetrics and Gynecology)",
        "MBBS, MD (General Medicine), DM (Cardiology)",
        "MBBS, MD (General Medicine), DM (Neurology)",
        "MBBS, MD (Dermatology, Venereology, and Leprosy)",
        "MBBS, MD (Psychiatry)",
        "MBBS, MD (Radiology)",
        "MBBS, MD (Pathology)",
        "MBBS, MS/MD (Ophthalmology)",
        "MBBS, MS (ENT)",
        "MBBS, MD (Anesthesiology)",
        "MBBS, MD (General Medicine), DM (Medical Oncology)",
        "MBBS, MS, MCh (Surgical Oncology)",
        "MBBS, MD (Radiation Oncology)",
        "MBBS, MD (General Medicine), DM (Endocrinology)",
        "MBBS, MD (General Medicine), DM (Gastroenterology)",
        "MBBS, MD, DM (Hepatology)",
        "MBBS, MD (General Medicine), DM (Nephrology)",
        "MBBS, MD (Pulmonary Medicine/Respiratory Medicine)",
        "MBBS, MD (General Medicine), DM (Rheumatology)",
        "MBBS, MD (Community Medicine)",
        "MBBS, MD (Emergency Medicine)",
        "MBBS, MD (Physical Medicine and Rehabilitation)",
        "MBBS, MS (Laparoscopic Surgery)",
        "MBBS, MS, MCh (Paediatric Surgery)",
        "MBBS, MS, MCh (Vascular Surgery)",
        "MBBS, MS, MCh (Burn Surgery)",
        "MBBS, MS, MCh (Spinal Surgery)",
        "MBBS, MS, MCh (Robotic Surgery)",
        "MBBS, MS, MCh (Transplant Surgery)",
        "MBBS, MS, MCh (Trauma Surgery)",
        "MBBS, MS, MCh (Hepato-Pancreato-Biliary Surgery)",
        "MBBS, MS, MCh (Head and Neck Surgery)",
        "MBBS, MD (General Medicine), DM (Clinical Hematology)",
        "MBBS, MD (General Medicine), DM (Metabolic Medicine)",
        "MBBS, MD (General Medicine), DM (Geriatric Cardiology)",
        "MBBS, MD (Paediatrics), DM (Neonatology)",
        "MBBS, MD (Paediatrics), DM (Paediatric Cardiology)",
        "MBBS, MD (Paediatrics), DM (Paediatric Neurology)",
        "MBBS, MD (Paediatrics), DM (Paediatric Endocrinology)",
        "MBBS, MD (Paediatrics), DM (Paediatric Pulmonology)",
        "MBBS, MD (Psychiatry), DM (Child and Adolescent Psychiatry)",
        "MBBS, MD (General Medicine), DM (Genetic Medicine)",
        "MBBS, MD (Nuclear Medicine)",
        "MBBS, MD (Interventional Radiology)",
        "MBBS, MD (Molecular Pathology)",
        "MBBS, MD (Cytogenetics)",
        "MBBS, MD (Forensic Pathology)",
        "MBBS, MD (Occupational Medicine)",
        "MBBS, MD (Epidemiology)",
        "MBBS, MD (Public Health)",
        "MBBS, MD (Preventive Oncology)",
        "MBBS, MD (Industrial Medicine)",
        "MBBS, MD, DM (Critical Care Nephrology)",
        "MBBS, MD, DM (Interventional Pulmonology)",
        "MBBS, MD, DM (Sleep Medicine)",
        "MBBS, MD, DM (Neurocritical Care)",
        "MBBS, MD, DM (Behavioral Neurology)",
        "MBBS, MS, MCh (Cosmetic Surgery)",
        "MBBS, MS, MCh (Oncoplastic Surgery)",
        "MBBS, MD, DM (Inborn Errors of Metabolism)",
        "MBBS, MD (Environmental Health)",
        "MBBS, MD, DM (Cardiac Electrophysiology)",
        "MBBS, MD (Paediatrics), DM (Pediatric Gastroenterology)",
        "MBBS, MD (Paediatrics), DM (Pediatric Hematology-Oncology)",
        "MBBS, MD (Paediatrics), DM (Pediatric Infectious Diseases)",
        "MBBS, MD (Paediatrics), DM (Pediatric Rheumatology)",
        "MBBS, MD (Paediatrics), DM (Pediatric Nephrology)",
        "MBBS, MD (Regenerative Medicine)",
        "MBBS, MD (Hyperbaric Medicine)",
        "MBBS, MD (Pain Medicine)",
        "MBBS, MD (Sleep Disorders Medicine)",
        "MBBS, MD (Telemedicine)",
        "MBBS, MD (General Medicine), DM (Autoimmune Diseases)",
        "MBBS, MD (General Medicine), DM (Thrombosis and Hemostasis)",
        "MBBS, MD (General Medicine), DM (Metabolic Bone Disorders)",
        "MBBS, MD (General Medicine), DM (Tropical Medicine)",
        "MBBS, MD (General Medicine), DM (Precision Medicine)",
        "MBBS, MD (Genomics and Personalized Medicine)",
        "MBBS, MD, PhD (Translational Medicine)",
        "MBBS, MD (Artificial Intelligence in Medicine)",
        "MBBS, MD (General Medicine), DM (Molecular Cardiology)",
        "MBBS, MD (General Medicine), DM (Immuno-Oncology)",
        "MBBS, MD (Clinical Laboratory Medicine)",
        "MBBS, MD (Medical Microbiology)",
        "MBBS, MD (Virology)",
        "MBBS, MD (Parasitology)",
        "MBBS, MD (Bacteriology)",
        "MBBS, MD (Bioinformatics in Medicine)",
        "MBBS, MD (Diagnostic Genomics)",
        "MBBS, MD (Histopathology)",
        "MBBS, MD (Tissue Engineering)",
        "MBBS, MD (Medical Biochemistry)",
        "MBBS, MD (Functional Medicine)",
        "MBBS, MD (Integrative Medicine)",
        "MBBS, MD (Anti-Aging Medicine)",
        "MBBS, MD (Lifestyle Medicine)",
        "MBBS, MD (Climate Change and Health)",
        "MBBS, MD (Medical Informatics)",
        "MBBS, MD (Humanitarian and Disaster Medicine)",
        "MBBS, MD (Geospatial Health)",
        "MBBS, MD (Palliative Medicine)",
        "MBBS, MD (Cannabis-Based Medicine)",
        "MBBS, MS, MCh (Neonatal Surgery)",
        "MBBS, MS, MCh (Reproductive Surgery)",
        "MBBS, MS, MCh (Endocrine Surgery)",
        "MBBS, MS, MCh (Microsurgery)",
        "MBBS, MS, MCh (Abdominal Wall Surgery)",
        "MBBS, MS, MCh (Peripheral Nerve Surgery)",
        "MBBS, MS, MCh (Pelvic Floor Surgery)",
        "MBBS, MS, MCh (Stereotactic Surgery)",
        "MBBS, MS, MCh (Epilepsy Surgery)",
        "MBBS, MS, MCh (Liver Transplant Surgery)",
        "MBBS, MD (Digital Health and Telemedicine)",
        "MBBS, MD (Nanomedicine)",
        "MBBS, MD (Robotic-Assisted Therapies)",
        "MBBS, MD (Biomedical Engineering in Medicine)",
        "MBBS, MD (Space Medicine)",
        "MBBS, MD (Geriatric Oncology)",
        "MBBS, MD (Adolescent Medicine)",
        "MBBS, MD (Military Medicine)",
        "MBBS, MD (Clinical Trial Design)",
        "MBBS, MD (Global Health Diplomacy)",
        "MBBS, MD (Paediatrics), DM (Pediatric Immunology)",
        "MBBS, MD (Paediatrics), DM (Pediatric Allergy)",
        "MBBS, MD (Paediatrics), DM (Pediatric Critical Care)",
        "MBBS, MD (Paediatrics), DM (Pediatric Emergency Medicine)",
        "MBBS, MD (Paediatrics), DM (Pediatric Dermatology)",
        "MBBS, MD (Rare Genetic Disorders)",
        "MBBS, MD (Rare Infectious Diseases)",
        "MBBS, MD (Orphan Drug Development)",
        "MBBS, MD (Dermatologic Surgery)",
        "MBBS, MD (Photomedicine)",
        "MBBS, MD (Critical Care Medicine)",
        "MBBS, MD (Sports Medicine)",
        "MBBS, MD (Geriatrics)",
        "MBBS, MD (Infectious Diseases)",
        "MBBS, MD (Immunology)",
        "MBBS, MD (Allergy and Immunology)",
        "MBBS, MD (Clinical Pharmacology)",
        "MBBS, MD (Hospital Administration)",
        "M.Sc. Food & Nutrition",
        "M.Sc. Nutrition & Dietetics",
        "M.Sc. Clinical Nutrition & Dietetics",
        "Bachelor of Dental Surgery",
        "Master of Dental Surgery",
        "MBBS, MD Senior consultant Internal medicine"
    ]

};

// Map user type value → qualification key
const qualKeyMap = { P: "doctor", N: "nurse", PT: "physio" };

// ─── Reusable Field Components ───────────────────────────────────────────────

const Label = ({ children, required }) => (
    <label className="block text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5">
        {children}
        {required && <span className="text-red-500 ml-1">*</span>}
    </label>
);

const Input = ({ type = "text", ...props }) => (
    <input
        type={type}
        className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-300"
        {...props}
    />
);

const Select = ({ children, ...props }) => (
    <select
        className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100 appearance-none cursor-pointer"
        {...props}
    >
        {children}
    </select>
);

const SectionCard = ({ icon, title, children }) => (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
        <div className="flex items-center gap-2 px-6 py-3 bg-slate-50 border-b border-slate-100">
            <span className="text-base">{icon}</span>
            <h2 className="text-xs font-bold uppercase tracking-widest text-blue-800">{title}</h2>
        </div>
        <div className="p-6">{children}</div>
    </div>
);

const FieldGrid = ({ children, cols = 3 }) => {
    const colClass =
        cols === 1
            ? "grid-cols-1"
            : cols === 2
                ? "grid-cols-1 sm:grid-cols-2"
                : "grid-cols-1 sm:grid-cols-2 l:grid-cols-3";
    return <div className={`grid ${colClass} gap-5`}>{children}</div>;
};

const Field = ({ label, required, children, colSpan = 1 }) => {
    const spanClass =
        colSpan === 2
            ? "sm:col-span-2"
            : colSpan === 3
                ? "lg:col-span-3 sm:col-span-2"
                : "";
    return (
        <div className={spanClass}>
            <Label required={required}>{label}</Label>
            {children}
        </div>
    );
};

// ─── Tag Input ────────────────────────────────────────────────────────────────

const TagInput = ({ tags, setTags }) => {
    const [input, setInput] = useState("");

    const addTag = (val) => {
        let cleaned = val.trim().replace(/,/g, "");
        // Capitalize first letter
        cleaned = cleaned.charAt(0).toUpperCase() + cleaned.slice(1).toLowerCase();

        if (cleaned && !tags.includes(cleaned)) {
            setTags([...tags, cleaned]);
        }

        setInput("");
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            addTag(input);
        }
        if (e.key === "Backspace" && !input && tags.length) {
            setTags(tags.slice(0, -1));
        }
    };

    return (
        <div
            className="flex flex-wrap gap-2 min-h-[42px] w-full rounded-lg border border-slate-200 bg-white px-3 py-2 focus-within:border-blue-400 focus-within:ring-2 focus-within:ring-blue-100 transition cursor-text"
            onClick={() => document.getElementById("tag-input").focus()}
        >
            {tags.map((tag) => (
                <span
                    key={tag}
                    className="flex items-center gap-1 bg-teal-50 text-teal-700 text-xs font-semibold px-2.5 py-1 rounded-md"
                >
                    {tag}
                    <button
                        type="button"
                        onClick={() => setTags(tags.filter((t) => t !== tag))}
                        className="text-teal-400 hover:text-teal-700 leading-none"
                    >
                        ×
                    </button>
                </span>
            ))}
            <input
                id="tag-input"
                value={input}
                onChange={(e) => {
                    const value = e.target.value;
                    // ADD TAG WHEN SPACE IS PRESSED
                    if (value.endsWith(" ")) {
                        addTag(value);
                        return;
                    }
                    setInput(value);
                }}
                onKeyDown={handleKeyDown}
                onBlur={() => input && addTag(input)}
                placeholder={tags.length === 0 ? "Type a language and press Enter…" : ""}
                className="flex-1 min-w-[120px] text-sm text-slate-800 outline-none bg-transparent placeholder:text-slate-300"
            />
        </div>
    );
};

// ─── Toggle ───────────────────────────────────────────────────────────────────



const Toggle = ({ label, description, checked, onChange, disabled = false, }) => (
    <div className="flex items-center justify-between py-3.5 px-6 border-b border-slate-100 last:border-0">
        <div>
            <p className="text-sm font-medium text-slate-700">{label}</p>
            {description && (
                <p className="text-xs text-slate-400 mt-0.5">
                    {description}
                </p>
            )}
        </div>

        <button
            type="button"
            disabled={disabled}
            onClick={() => !disabled && onChange(!checked)}
            className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none
            ${checked ? "bg-teal-500" : "bg-slate-200"}
            ${disabled ? "opacity-70 cursor-not-allowed" : "cursor-pointer"}
            `}
        >
            <span
                className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-sm transition duration-200 ease-in-out ${checked ? "translate-x-5" : "translate-x-0"
                    }`}
            />
        </button>
    </div>
);

// ─── Profile Picture Upload ───────────────────────────────────────────────────

const ProfilePicUpload = ({ onUpload }) => {
    const [preview, setPreview] = useState(null);
    const inputRef = useRef();
    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
    const handleChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        // FILE SIZE VALIDATION
        if (file.size > MAX_FILE_SIZE) {
            message.error("File size must be less than 10 MB");
            e.target.value = "";
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            setPreview(result);
            const base64 = result.split(",")[1];
            if (onUpload) {
                onUpload(base64, file.type);
            }
        };
        reader.readAsDataURL(file);
    };

    return (
        <div className="flex flex-col items-center gap-3">
            <div
                onClick={() => inputRef.current.click()}
                className="relative w-24 h-24 rounded-full border-2 border-dashed border-slate-300 bg-slate-50 flex items-center justify-center cursor-pointer overflow-hidden"
            >
                {preview ? (
                    <img
                        src={preview}
                        alt="Profile"
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <span className="text-xs text-slate-400">
                        Upload
                    </span>
                )}
            </div>
            <div className="text-center">
                <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest">Profile Photo</p>
                <p className="text-[11px] text-slate-400 mt-0.5">JPG, PNG up to 10MB</p>
            </div>
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleChange}
            />
        </div>
    );
};

// ─── File Upload ──────────────────────────────────────────────────────────────


const FileUpload = ({ label, icon, id, accept = "image/*", hint, required = false, onChange,
}) => {

    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);

    // MODAL STATES
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileURL, setFileURL] = useState("");

    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
    const handleInternalChange = (e) => {
        const selectedFile = e.target.files?.[0];
        if (!selectedFile) return;
        // FILE SIZE VALIDATION
        if (selectedFile.size > MAX_FILE_SIZE) {
            message.error("File size must be less than 10 MB");
            e.target.value = "";
            return;
        }
        setFile(selectedFile);
        // parent handler
        if (onChange) {
            onChange(e);
        }
        // image preview
        if (selectedFile.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(selectedFile);
        } else {
            setPreview(null);
        }
    };

    const handleRemove = () => {
        setFile(null);
        setPreview(null);
        setFileURL("");

        const input = document.getElementById(id);

        if (input) {
            input.value = "";
        }
    };
    // OPEN MODAL
    const handleView = () => {
        if (!file) return;

        const url = URL.createObjectURL(file);

        setFileURL(url);
        setIsModalOpen(true);
    };

    return (
        <div>
            {label && <Label required={required}>{label}</Label>}

            {!file ? (
                <label
                    htmlFor={id}
                    className="flex items-center gap-3 rounded-lg border-2 border-dashed border-slate-200 bg-slate-50 px-4 py-3 cursor-pointer hover:border-blue-300 hover:bg-blue-50 transition"
                >
                    <span className="text-2xl">{icon}</span>

                    <div>
                        <p className="text-xs text-slate-400">
                            <span className="font-semibold text-blue-500">
                                Click to upload
                            </span>{" "}
                            or drag & drop
                        </p>

                        <p className="text-xs text-slate-400 mt-0.5">
                            {hint || "No file chosen"}
                        </p>
                    </div>

                    <input
                        id={id}
                        type="file"
                        accept={accept}
                        className="hidden"
                        onChange={handleInternalChange}
                    />
                </label>
            ) : (
                <div className="mt-2 border rounded-lg p-3 bg-slate-50 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                    <div className="flex items-center gap-3 self-end sm:self-auto flex-shrink-0">
                        {preview ? (
                            <img
                                src={preview}
                                alt="preview"
                                className="w-12 h-12 object-cover rounded-md border"
                            />
                        ) : (
                            <span className="text-xl">{icon}</span>
                        )}

                        <div>
                            <p className="text-sm text-slate-700 truncate max-w-[150px]">
                                {file.name}
                            </p>

                            <p className="text-xs text-slate-400">
                                {(file.size / 1024).toFixed(1)} KB
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center gap-3">
                        {/* VIEW BUTTON */}
                        <button
                            type="button"
                            onClick={handleView}
                            className="text-blue-500 text-xs font-semibold hover:text-blue-600"
                        >
                            View
                        </button>

                        {/* REMOVE BUTTON */}
                        <button
                            type="button"
                            onClick={handleRemove}
                            className="text-red-500 text-xs font-semibold hover:text-red-600"
                        >
                            Remove
                        </button>
                    </div>
                </div>
            )}

            {/* VIEW MODAL */}
            <Modal
                open={isModalOpen}
                footer={null}
                onCancel={() => setIsModalOpen(false)}
                width={900}
            >
                {file?.type?.startsWith("image/") ? (
                    <img
                        src={fileURL}
                        alt="preview"
                        className="w-full max-h-[80vh] object-contain"
                    />
                ) : file?.type === "application/pdf" ? (
                    <iframe
                        src={fileURL}
                        title="PDF Preview"
                        width="100%"
                        height="600px"
                    />
                ) : (
                    <div className="text-center py-10">
                        <p className="text-slate-500">
                            Preview not available for this file type
                        </p>
                    </div>
                )}
            </Modal>
        </div>
    );
};
// ─── Fee Input ────────────────────────────────────────────────────────────────

// const FeeInput = ({ label }) => (
//     <Field label={label}>
//         <div className="relative">
//             <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm font-semibold pointer-events-none">
//                 INR
//             </span>
//             <input
//                 type="number"
//                 defaultValue={0}
//                 min={0}
//                 className="w-full rounded-lg border border-slate-200 bg-white pl-10 pr-3 py-2 text-sm text-slate-800 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100"
//             />
//         </div>
//     </Field>
// );

const ConsultationSchedule = ({ label, type, consultationData, setConsultationData, }) => {
    const loggedUserObj = sessionStorage.getItem("login_result");
    const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
    
    const days = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
    ];

    const currentData = consultationData[type];

    const handleChange = (field, value) => {
        setConsultationData((prev) => ({
            ...prev,
            [type]: {
                ...prev[type],
                [field]: value,
            },
        }));
    };

    return (
        <div className="rounded-xl border border-slate-200 p-4 bg-slate-50">
            <h3 className="text-sm font-semibold text-slate-700 mb-4">
                {label}
            </h3>

            {/* Fee */}
            <div className="mb-4">
                <Label>Consultation Fee</Label>

                <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm font-semibold pointer-events-none">
                        {loggedUser?.user?.currencyCode}
                    </span>

                    <input
                        type="number"
                        min={0}
                        value={currentData.fee}
                        onChange={(e) =>
                            handleChange("fee", e.target.value)
                        }
                        className="w-full rounded-lg border border-slate-200 bg-white pl-10 pr-3 py-2 text-sm"
                    />
                </div>
            </div>



            {/* Days */}
            <div className="mb-4">
                <Label>Select Days</Label>

                <div className="grid grid-cols-2 gap-2">
                    {days.map((day) => (
                        <label
                            key={day}
                            className="flex items-center gap-2 text-sm text-slate-600 capitalize"
                        >
                            <input
                                type="checkbox"
                                checked={currentData[day]}
                                onChange={(e) =>
                                    handleChange(day, e.target.checked)
                                }
                            />

                            {day}
                        </label>
                    ))}
                </div>
            </div>

            {/* Time */}
            <div className="mb-4">
                <Label>Consultation Time</Label>
                <RangePicker
                    use12Hours
                    format="hh:mm A"
                    minuteStep={1}
                    showNow={false}
                    needConfirm={false}
                    changeOnScroll
                    inputReadOnly={false}
                    className="w-full h-10"
                    value={[
                        currentData.fromTime
                            ? dayjs(currentData.fromTime, "hh:mm A")
                            : null,
                        currentData.toTime
                            ? dayjs(currentData.toTime, "hh:mm A")
                            : null,
                    ]}
                    onCalendarChange={(times, timeStrings) => {
                        handleChange("fromTime", timeStrings[0] || "");
                        handleChange("toTime", timeStrings[1] || "");
                    }}

                />
            </div>
        </div>
    );
};

// ─── Main Form ────────────────────────────────────────────────────────────────

const DoctorEnrollmentForm = () => {
    const [languages, setLanguages] = useState(["English"]);
    const [userType, setUserType] = useState("P");
    const [toggles, setToggles] = useState({
        publishSlots: false,
        displayWebsite: false,
        himsApplicable: false,
    });
    const [countryList, setCountryList] = useState([]);
    const [specialityList, setSpecialityList] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stateList, setStateList] = useState([]);
    const [clinicCityList, setClinicCityList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [resetKey, setResetKey] = useState(0);
    const initialFormData = {
        hospitalName: "",
        city_Name: "",
        clinicAddress1: "",
        clinicAddress2: "",
        clinicCity: "",
        clinicState: "",
        clinicCountry: "",
        clinicPincode: "",

        salutation: "Dr.",
        firstName: "",
        lastName: "",
        qualification: "",
        otherQualification: "",
        fellowship: "",
        speciality: "",
        specialityCode: "",
        dob: "",
        gender: "",

        email: "",
        mobile: "",
        experience: "",
        registrationNumber: "",

        address1: "",
        city: "",
        state: "",
        country: "",
        pincode: "",

        bankAccountNumber: "",
        bankAccountName: "",
        bankName: "",
        bankBranch: "",
        ifscCode: "",

        profileImage: "",
        profileImageType: "",
        registrationFormImage: "",
        registrationFormType: "",
        degreeCertificate: "",
        degreeCertificateType: "",
        doctorSignature: "",
        doctorSignatureType: "",
        doctorStamp: "",
        doctorStampType: "",
    };
    const [formData, setFormData] = useState(initialFormData);
    const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    };
    const today = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(today.getFullYear() + 1);
    const [consultationData, setConsultationData] = useState({
        inPerson: {
            fee: 0,
            fromTime: "",
            toTime: "",
            fromDate: formatDate(today),
            toDate: formatDate(nextYear),
            consultationDuration: "15",

            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
        },

        video: {
            fee: 0,
            fromTime: "",
            toTime: "",
            fromDate: formatDate(today),
            toDate: formatDate(nextYear),
            consultationDuration: "15",

            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
        },

        homeVisit: {
            fee: 0,
            fromTime: "",
            toTime: "",
            fromDate: formatDate(today),
            toDate: formatDate(nextYear),
            consultationDuration: "15",

            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
        },
    });
    const [errors, setErrors] = useState({});
    const fetchCountries = async () => {
        try {
            const payload = {
                status: 1,
            };
            const res = await CommonService.CountriesList(payload);
            const formattedCountries =
                res?.data?.map((item) => ({
                    label: item.country_Name,
                    value: item.country_Id,
                })) || [];
            setCountryList(formattedCountries);
        } catch (error) {
            console.error("Country API Error", error);
        }
    };
    const fetchStates = async () => {
        try {
            const res = await enrollmentServices.StateMaster();

            const formattedStates =
                res?.data?.map((item) => ({
                    label: item.stateName,
                    value: item.stateId,
                })) || [];

            setStateList(formattedStates);

        } catch (error) {
            console.log("State API Error", error);
        }
    };
    const fetchCities = async (type = "clinic") => {
        try {
            const payload = {
                status: 1,
            };
            const res = await CommonService.CityList(payload);
            const formattedCities =
                res?.data?.map((item) => ({
                    label: item.cityName,
                    value: item.cityName,
                    stateId: item.stateId,   // important
                })) || [];

            if (type === "clinic") {
                setClinicCityList(formattedCities);
            } else {
                setCityList(formattedCities);
            }
        } catch (error) {
            console.log("City API Error", error);
        }
    };
    const fetchStateById = async (stateId, type = "clinic") => {
        try {
            const res = await enrollmentServices.StateMaster();
            const selectedState = res?.data?.find((item) => item.stateId === stateId);
            if (selectedState) {
                if (type === "clinic") {
                    setFormData((prev) => ({
                        ...prev,
                        clinicState: selectedState.stateName,
                    }));
                } else {
                    setFormData((prev) => ({
                        ...prev,
                        state: selectedState.stateName,
                    }));
                }
            }
        } catch (error) {
            console.log("State fetch error", error);
        }
    };
    const fetchSpecialityList = async () => {
        try {
            const payload = {
                // status: 1,
            };
            const response = await UserService.getDoctorSpeciality(payload);
            console.log("Speciality API Response:", response);
            if (response?.data) {
                setSpecialityList(response.data);
            }
        } catch (error) {
            console.log("Error fetching speciality list", error);
        }
    };
    useEffect(() => {
        fetchCountries();
        fetchSpecialityList();
        fetchStates();
    }, []);
    const nutritionQualifications = [
        "M.Sc. Food & Nutrition",
        "M.Sc. Nutrition & Dietetics",
        "M.Sc. Clinical Nutrition & Dietetics",
    ];
    const isNutritionQualification =
        nutritionQualifications.includes(formData.qualification);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };
    const validateForm = () => {
        let newErrors = {};
        // Hospital Details
        if (!formData.hospitalName.trim()) {
            newErrors.hospitalName = true;
        }
        if (!formData.clinicAddress1.trim()) {
            newErrors.clinicAddress1 = true;
        }
        if (!formData.clinicCity.trim()) {
            newErrors.clinicCity = true;
        }
        if (!formData.clinicState.trim()) {
            newErrors.clinicState = true;
        }
        if (!formData.clinicCountry) {
            newErrors.clinicCountry = true;
        }
        if (!formData.clinicPincode.trim()) {
            newErrors.clinicPincode = true;
        }
        // Personal Details
        if (!formData.firstName.trim()) {
            newErrors.firstName = true;
        }
        if (!formData.lastName.trim()) {
            newErrors.lastName = true;
        }
        if (!formData.qualification) {
            newErrors.qualification = true;
        }
        if (!formData.speciality) {
            newErrors.speciality = true;
        }
        if (!formData.dob) {
            newErrors.dob = true;
        }
        if (!formData.gender) {
            newErrors.gender = true;
        }
        // Contact
        if (!formData.email.trim()) {
            newErrors.email = true;
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
        ) {
            newErrors.email = true;
        }
        if (!formData.mobile.trim()) {
            newErrors.mobile = true;
        } else if (!/^[0-9]{10,15}$/.test(formData.mobile)) {
            newErrors.mobile = true;
        }
        if (!formData.experience.trim()) {
            newErrors.experience = true;
        }
        // Registration Number Required only for non nutrition qualifications
        if (
            !isNutritionQualification &&
            !formData.registrationNumber.trim()
        ) {
            newErrors.registrationNumber = true;
        }
        // File Validation
        if (
            isNutritionQualification &&
            !formData.degreeCertificate
        ) {
            newErrors.degreeCertificate = true;
        }

        if (
            !isNutritionQualification &&
            !formData.registrationFormImage
        ) {
            newErrors.registrationFormImage = true;
        }
        // Files
        // if (!formData.profileImage) {
        //     newErrors.profileImage = true;
        // }
        // if (!formData.registrationFormImage) {
        //     newErrors.registrationFormImage = true;
        // }
        if (!formData.doctorSignature) {
            newErrors.doctorSignature = true;
        }
        if (!formData.doctorStamp) {
            newErrors.doctorStamp = true;
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            message.error("Please fill the marked * required fields");
            return false;
        }
        return true;
    };
    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => {
                const base64 = reader.result.split(",")[1];
                resolve(base64);
            };

            reader.onerror = (error) => reject(error);
        });
    };
    const handleFileUpload = async (e, fieldName, typeField) => {
        const file = e.target.files[0];
        if (!file) return;
        const base64 = await convertToBase64(file);
        setFormData((prev) => ({
            ...prev,
            [fieldName]: base64,
            [typeField]: file.type,
        }));

        setErrors((prev) => ({
            ...prev,
            [fieldName]: "",
        }));
    };
    const qualKey = qualKeyMap[userType];
    const qualOptions = qualKey ? qualificationList[qualKey] : [];

    const setToggle = (key) => (val) =>
        setToggles((prev) => ({ ...prev, [key]: val }));

    const handleWebsiteAndSlotsToggle = (value) => {
        setToggles((prev) => ({
            ...prev,
            displayWebsite: value,
            publishSlots: value,
        }));
    };
    const handleHimsToggle = (value) => {
        setToggles((prev) => ({
            ...prev,
            himsApplicable: value,
        }));
    };
    const formatDateToMMDDYYYY = (date) => {
        if (!date) return "";
        const [year, month, day] = date.split("-");
        return `${month}/${day}/${year}`;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = validateForm();

        if (!isValid) {
            return;
        }

        setIsSubmitting(true);

        try {
            const payload = {
                accountDetails: {
                    account_Name: formData.hospitalName,
                    country_Id: formData.clinicCountry,
                },

                appointmentTemplateDetails: [
                    {
                        inPerson:
                            consultationData.inPerson.fee ||
                                consultationData.inPerson.fromTime ||
                                consultationData.inPerson.toTime
                                ? "Y"
                                : "N",

                        fromDate: consultationData.inPerson.fromDate,
                        toDate: consultationData.inPerson.toDate,
                        consultationDuration:
                            consultationData.inPerson.consultationDuration,

                        fromTime: consultationData.inPerson.fromTime,
                        toTime: consultationData.inPerson.toTime,

                        monday: consultationData.inPerson.monday ? "Y" : "N",
                        tuesday: consultationData.inPerson.tuesday ? "Y" : "N",
                        wednesday: consultationData.inPerson.wednesday ? "Y" : "N",
                        thursday: consultationData.inPerson.thursday ? "Y" : "N",
                        friday: consultationData.inPerson.friday ? "Y" : "N",
                        saturday: consultationData.inPerson.saturday ? "Y" : "N",
                        sunday: consultationData.inPerson.sunday ? "Y" : "N",

                        inpersonFee: Number(consultationData.inPerson.fee),
                    },

                    {
                        video:
                            consultationData.video.fee ||
                                consultationData.video.fromTime ||
                                consultationData.video.toTime
                                ? "Y"
                                : "N",

                        fromDate: consultationData.video.fromDate,
                        toDate: consultationData.video.toDate,
                        consultationDuration:
                            consultationData.video.consultationDuration,

                        fromTime: consultationData.video.fromTime,
                        toTime: consultationData.video.toTime,

                        monday: consultationData.video.monday ? "Y" : "N",
                        tuesday: consultationData.video.tuesday ? "Y" : "N",
                        wednesday: consultationData.video.wednesday ? "Y" : "N",
                        thursday: consultationData.video.thursday ? "Y" : "N",
                        friday: consultationData.video.friday ? "Y" : "N",
                        saturday: consultationData.video.saturday ? "Y" : "N",
                        sunday: consultationData.video.sunday ? "Y" : "N",

                        videoFee: Number(consultationData.video.fee),
                    },

                    {
                        homeVisit:
                            consultationData.homeVisit.fee ||
                                consultationData.homeVisit.fromTime ||
                                consultationData.homeVisit.toTime
                                ? "Y"
                                : "N",

                        fromDate: consultationData.homeVisit.fromDate,
                        toDate: consultationData.homeVisit.toDate,
                        consultationDuration:
                            consultationData.homeVisit.consultationDuration,

                        fromTime: consultationData.homeVisit.fromTime,
                        toTime: consultationData.homeVisit.toTime,

                        monday: consultationData.homeVisit.monday ? "Y" : "N",
                        tuesday: consultationData.homeVisit.tuesday ? "Y" : "N",
                        wednesday: consultationData.homeVisit.wednesday ? "Y" : "N",
                        thursday: consultationData.homeVisit.thursday ? "Y" : "N",
                        friday: consultationData.homeVisit.friday ? "Y" : "N",
                        saturday: consultationData.homeVisit.saturday ? "Y" : "N",
                        sunday: consultationData.homeVisit.sunday ? "Y" : "N",

                        homeVisitFee: Number(consultationData.homeVisit.fee),
                    },
                ],

                clinicDetails: {
                    city_Name: formData.clinicCity,
                    clinicAddress: formData.clinicAddress1,
                    account_Name: formData.hospitalName,
                    area_Name: formData.clinicAddress2,
                    clinic_Name: formData.clinic_Name,
                    contactNo: formData.mobile,
                    country_Id: formData.clinicCountry,
                    pincode: formData.clinicPincode,
                    state_Id: formData.clinicState,
                },

                userDetails: {
                    image: formData.profileImage,
                    imageType: formData.profileImageType,
                    salutation: formData.salutation,
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    qualification: formData.qualification,
                    otherQualification: formData.otherQualification,
                    fellowship: formData.fellowship,
                    speciality: formData.speciality,
                    dob: formatDateToMMDDYYYY(formData.dob),
                    gender: formData.gender,
                    email: formData.email,
                    mobile: formData.mobile,
                    registrationNumber: formData.registrationNumber,
                    address1: formData.address1,
                    city: formData.city,
                    state: formData.state,
                    country: formData.country,
                    pincode: formData.pincode,
                    bankAccountNumber: formData.bankAccountNumber,
                    bankAccountName: formData.bankAccountName,
                    bankName: formData.bankName,
                    bankBranch: formData.bankBranch,
                    ifscCode: formData.ifscCode,
                    experience: formData.experience,
                    ...(isNutritionQualification
                        ? {
                            degreeCertificate: formData.degreeCertificate,
                            degreeCertificateType: formData.degreeCertificateType,
                        }
                        : {
                            registrationFormImage: formData.registrationFormImage,
                            registrationFormType: formData.registrationFormType,
                        }),
                    doctorSignature: formData.doctorSignature,
                    doctorSignatureType: formData.doctorSignatureType,
                    doctorStamp: formData.doctorStamp,
                    doctorStampType: formData.doctorStampType,
                    publishSlots: toggles.publishSlots ? "Y" : "N",
                    displayInWebsite: toggles.displayWebsite ? "Y" : "N",
                    himsApplicable: toggles.himsApplicable ? "Y" : "N",

                    userMappedLanguages: languages.map((lang) => ({
                        languageName: lang,
                        status: 1,
                    })),
                },
            };
            const response = await UserService.addEnrollmentUser(payload);
            console.log("API RESPONSE", response);
            message.success("Doctor enrollment submitted successfully!");
            // RESET FORM DATA
            setFormData(initialFormData);
            setErrors({});
            setResetKey((prev) => prev + 1);

            // RESET LANGUAGES
            setLanguages(["English"]);

            // RESET TOGGLES
            setToggles({
                publishSlots: false,
                displayWebsite: false,
                himsApplicable: false,
            });

            // RESET CONSULTATION DATA
            setConsultationData({
                inPerson: {
                    fee: 0,
                    fromTime: "",
                    toTime: "",
                    fromDate: formatDate(today),
                    toDate: formatDate(nextYear),
                    consultationDuration: "15",

                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                    sunday: false,
                },

                video: {
                    fee: 0,
                    fromTime: "",
                    toTime: "",
                    fromDate: formatDate(today),
                    toDate: formatDate(nextYear),
                    consultationDuration: "15",

                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                    sunday: false,
                },

                homeVisit: {
                    fee: 0,
                    fromTime: "",
                    toTime: "",
                    fromDate: formatDate(today),
                    toDate: formatDate(nextYear),
                    consultationDuration: "15",

                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                    sunday: false,
                },
            });
            // CLEAR ERRORS
            setErrors({});
        } catch (error) {
            console.log("FULL ERROR", error);
            message.error("Failed to submit enrollment");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleReset = () => {
        // RESET FORM DATA
        setFormData(initialFormData);
        setErrors({});
        setResetKey((prev) => prev + 1);
        // RESET LANGUAGES
        setLanguages(["English"]);
        // RESET USER TYPE
        setUserType("P");
        // RESET TOGGLES
        setToggles({
            publishSlots: false,
            displayWebsite: false,
            himsApplicable: false,
        });

        // RESET CONSULTATION DATA
        setConsultationData({
            inPerson: {
                fee: 0,
                fromTime: "",
                toTime: "",
                fromDate: formatDate(today),
                toDate: formatDate(nextYear),
                consultationDuration: "15",
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
            },

            video: {
                fee: 0,
                fromTime: "",
                toTime: "",
                fromDate: formatDate(today),
                toDate: formatDate(nextYear),
                consultationDuration: "15",
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
            },

            homeVisit: {
                fee: 0,
                fromTime: "",
                toTime: "",
                fromDate: formatDate(today),
                toDate: formatDate(nextYear),
                consultationDuration: "15",
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
            },
        });
        // CLEAR ERRORS
        setErrors({});
        message.success("Form reset successfully");
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-100 to-blue-50">
            {/* Header */}
            <div className="bg-[#F1FFF9] w-full fixed text-white px-8 py-7 flex items-center gap-4 shadow-lg z-10">
                <img className="w-28" src={doxzonLogo} alt="icon" />
                <div>
                    <h1 className="text-2xl font-bold tracking-tight text-[#189FAA]">Doctor Enrollment</h1>
                </div>
            </div>

            <form
                onSubmit={handleSubmit}
                onReset={handleReset}
                className="max-w-4xl mx-auto px-4 py-8 flex flex-col gap-6"
            >
                <div className="mt-24">
                    <p className="text-sm text-slate-500">
                        Fields marked with <span className="text-red-500">*</span> are required
                    </p>
                </div>

                {/* 1. Account Info */}
                <SectionCard
                    icon={<MdAccountBalance />}
                    title="Hospital / Clinic Information"
                >
                    <FieldGrid cols={3}>
                        <Field label="Hospital / Clinic Name" required>
                            <Input
                                name="hospitalName"
                                value={formData.hospitalName}
                                onChange={handleChange}
                                placeholder="Hospital / Clinic name" />

                        </Field>

                        <Field label="Branch Name">
                            <Input
                                name="clinic_Name"
                                value={formData.clinic_Name}
                                onChange={handleChange}
                                placeholder="Branch name"
                            />

                        </Field>

                        {/* Address Line 1 */}
                        <Field label="Address Line 1" required>
                            <Input
                                name="clinicAddress1"
                                value={formData.clinicAddress1}
                                onChange={handleChange}
                                placeholder="Door no, street, area"
                            />
                        </Field>

                        {/* Address Line 2 */}
                        <Field label="Address Line 2">
                            <Input
                                name="clinicAddress2"
                                value={formData.clinicAddress2}
                                onChange={handleChange}
                                placeholder="Landmark / locality"
                            />
                        </Field>

                        {/* Clinic City */}
                        <Field label="City" required>
                            <AntdSelect
                                showSearch
                                placeholder="Select City"
                                optionFilterProp="children"
                                className="w-full"
                                value={formData.clinicCity || undefined}
                                onDropdownVisibleChange={(open) => {
                                    if (open && clinicCityList.length === 0) {
                                        fetchCities("clinic");
                                    }
                                }}
                                onChange={(value) => {
                                    const selectedCity = clinicCityList.find(
                                        (city) => city.value === value
                                    );
                                    setFormData((prev) => ({
                                        ...prev,
                                        clinicCity: value,
                                    }));
                                    if (selectedCity?.stateId) {
                                        fetchStateById(selectedCity.stateId, "clinic");
                                    }
                                }}
                            >
                                {clinicCityList.map((city) => (
                                    <Option
                                        key={city.value}
                                        value={city.value}
                                    >
                                        {city.label}
                                    </Option>
                                ))}
                            </AntdSelect>
                        </Field>

                        {/* Clinic State */}
                        <Field label="State" required>
                            <AntdSelect
                                showSearch
                                placeholder="Select State"
                                optionFilterProp="children"
                                className="w-full"
                                value={formData.clinicState}
                                onChange={(value) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        clinicState: value,
                                        clinicCity: "",
                                    }));
                                    fetchCities(value, "clinic");
                                }}
                            >
                                {stateList.map((state) => (
                                    <Option
                                        key={state.value}
                                        value={state.value}
                                    >
                                        {state.label}
                                    </Option>
                                ))}
                            </AntdSelect>
                        </Field>

                        {/* Clinic Country */}
                        <Field label="Country" required>
                            <Select
                                name="clinicCountry"
                                value={formData.clinicCountry}
                                onChange={handleChange}
                            >
                                <option value="">Select Country</option>

                                {countryList.map((country) => (
                                    <option
                                        key={country.value}
                                        value={country.value}
                                    >
                                        {country.label}
                                    </option>
                                ))}
                            </Select>
                        </Field>

                        {/* Clinic Pincode */}
                        <Field label="Pincode" required>
                            <Input
                                name="clinicPincode"
                                value={formData.clinicPincode}
                                onChange={handleChange}
                                placeholder="600001"
                                maxLength={6}
                            />
                        </Field>

                    </FieldGrid>
                </SectionCard>

                {/* 2. Personal Info */}
                <SectionCard icon={<IoMdPerson />} title="Personal Information">
                    {/* Profile Picture */}
                    <div className="flex justify-center mb-6 pb-6 border-b border-slate-100">
                        <ProfilePicUpload
                            key={`profile-${resetKey}`}
                            onUpload={(base64, type) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    profileImage: base64,
                                    profileImageType: type,
                                }));
                            }}
                        />
                    </div>

                    <FieldGrid cols={3}>
                        <Field label="First Name" required>
                            <div className="flex gap-2">
                                {/* Salutation Select */}
                                <select
                                    name="salutation"
                                    value={formData.salutation}
                                    onChange={handleChange}
                                    className="w-14 rounded-lg border border-slate-200 bg-white px-2 py-2 text-sm text-slate-800 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100"
                                >
                                    <option value=""></option>
                                    <option value="Dr.">Dr.</option>
                                    <option value="Dt.">Dt.</option>
                                </select>

                                {/* First Name Input */}
                                <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    placeholder="First name"
                                    className="flex-1 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-300"
                                />
                            </div>
                        </Field>
                        <Field label="Last Name" required>
                            <Input
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                placeholder="Last name" />
                        </Field>

                        {/* Dynamic Qualification */}
                        <Field label="Qualification" required>
                            {qualOptions.length > 0 ? (
                                <>
                                    <AntdSelect
                                        showSearch
                                        placeholder="Select Qualification"
                                        optionFilterProp="children"
                                        className="w-full"
                                        value={formData.qualification}
                                        onChange={(value) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                qualification: value,
                                            }))
                                        }
                                    >
                                        {qualOptions.map((q) => (
                                            <Option key={q} value={q}>
                                                {q}
                                            </Option>
                                        ))}
                                    </AntdSelect>
                                </>
                            ) : (
                                <Input
                                    name="qualification"
                                    value={formData.qualification}
                                    onChange={handleChange}
                                    placeholder="Enter qualification"
                                />
                            )}
                        </Field>

                        <Field label="Other Qualification">
                            <Input
                                name="otherQualification"
                                value={formData.otherQualification}
                                onChange={handleChange}
                                placeholder="Additional qualifications"
                            />
                        </Field>
                        <Field label="Fellowship">
                            <Input
                                name="fellowship"
                                value={formData.fellowship}
                                onChange={handleChange}
                                placeholder="Fellowship details"
                            />
                        </Field>
                        <Field label="Speciality" required>
                            <>
                                <AntdSelect
                                    showSearch
                                    placeholder="Select Speciality"
                                    optionFilterProp="children"
                                    className="w-full"
                                    value={formData.speciality}
                                    onChange={(value) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            speciality: value,
                                        }))
                                    }
                                >
                                    {specialityList.map((item) => (
                                        <Option
                                            key={item.id}
                                            value={item.speciality}
                                        >
                                            {item.speciality}
                                        </Option>
                                    ))}
                                </AntdSelect>
                            </>
                        </Field>
                        <Field label="Date of Birth" required>
                            <Input
                                type="date"
                                name="dob"
                                value={formData.dob}
                                onChange={handleChange}
                            />
                        </Field>
                        <Field label="Gender" required>
                            <Select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                            >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                                <option value="Prefer not to say">
                                    Prefer not to say
                                </option>
                            </Select>
                        </Field>
                        <Field label="Languages Known" required colSpan={3}>
                            <TagInput tags={languages} setTags={setLanguages} />
                        </Field>
                    </FieldGrid>
                </SectionCard>

                {/* 3. Contact Info */}
                <SectionCard icon={<RiContactsFill />} title="Contact Information">
                    <FieldGrid cols={3}>
                        <Field label="Email" required>
                            <Input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="doctor@example.com"
                            />
                        </Field>
                        <Field label="Mobile" required>
                            <Input
                                type="tel"
                                name="mobile"
                                maxLength={15}
                                value={formData.mobile}
                                onChange={handleChange}
                                placeholder="Enter mobile number"
                            />
                        </Field>
                        <Field label="Experience (Years)" required>
                            <Input
                                name="experience"
                                value={formData.experience}
                                onChange={handleChange}
                                placeholder="Years of experience"
                            />
                        </Field>
                        {/* Hide Registration Number for Nutrition Qualifications */}
                        {!isNutritionQualification && (
                            <Field label="Reg. No" required>
                                <Input
                                    name="registrationNumber"
                                    value={formData.registrationNumber}
                                    onChange={handleChange}
                                    placeholder="Registration number"
                                />
                            </Field>
                        )}

                        {/* Dynamic Certificate Upload */}
                        <Field colSpan={3}>
                            <FileUpload
                                key={`reg-cert-${resetKey}`}
                                label={
                                    isNutritionQualification
                                        ? "Degree Certificate"
                                        : "Registration Certificate"
                                }
                                required
                                icon={<IoDocumentTextOutline />}
                                id="reg-cert-upload"
                                accept=".pdf,.jpg,.jpeg,.png"
                                hint="PDF,JPEG,JPG or PNG up to 10MB"
                                onChange={(e) =>
                                    handleFileUpload(
                                        e,
                                        isNutritionQualification
                                            ? "degreeCertificate"
                                            : "registrationFormImage",
                                        isNutritionQualification
                                            ? "degreeCertificateType"
                                            : "registrationFormType"
                                    )
                                }
                            />
                        </Field>
                    </FieldGrid>
                </SectionCard>

                {/* 4. Address */}
                <SectionCard icon={<FaRegAddressCard />} title="Address (Personal)">
                    <FieldGrid cols={3}>
                        <Field label="Flat / Door No & Area" colSpan={2} required>
                            <Input
                                name="address1"
                                value={formData.address1}
                                onChange={handleChange}
                                placeholder="Flat no, building, street, area"
                            />
                        </Field>
                        <Field label="City" required>
                            <AntdSelect
                                showSearch
                                placeholder="Select City"
                                optionFilterProp="children"
                                className="w-full"
                                value={formData.city || undefined}
                                onDropdownVisibleChange={(open) => {
                                    if (open && cityList.length === 0) {
                                        fetchCities("personal");
                                    }
                                }}
                                onChange={(value) => {
                                    const selectedCity = cityList.find(
                                        (city) => city.value === value
                                    );

                                    setFormData((prev) => ({
                                        ...prev,
                                        city: value,
                                    }));

                                    if (selectedCity?.stateId) {
                                        fetchStateById(selectedCity.stateId, "personal");
                                    }
                                }}
                            >
                                {cityList.map((city) => (
                                    <Option
                                        key={city.value}
                                        value={city.value}
                                    >
                                        {city.label}
                                    </Option>
                                ))}
                            </AntdSelect>
                        </Field>
                        <Field label="State" required>
                            <AntdSelect
                                showSearch
                                placeholder="Select State"
                                optionFilterProp="children"
                                className="w-full"
                                value={formData.state}
                                onChange={(value) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        state: value,
                                        city: "",
                                    }));

                                    fetchCities(value, "personal");
                                }}
                            >
                                {stateList.map((state) => (
                                    <Option
                                        key={state.value}
                                        value={state.value}
                                    >
                                        {state.label}
                                    </Option>
                                ))}
                            </AntdSelect>
                        </Field>
                        <Field label="Country" required>
                            <Select
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                            >
                                <option value="">Select Country</option>

                                {countryList.map((country) => (
                                    <option
                                        key={country.value}
                                        value={country.value}
                                    >
                                        {country.label}
                                    </option>
                                ))}
                            </Select>
                        </Field>
                        <Field label="Pincode" required>
                            <Input
                                name="pincode"
                                value={formData.pincode}
                                onChange={handleChange}
                                placeholder="000000"
                                maxLength={6}
                            />
                        </Field>
                    </FieldGrid>
                </SectionCard>

                {/* 5. Bank Details */}
                <SectionCard icon={<GiBank />} title="Bank Details">
                    <FieldGrid cols={3}>
                        <Field label="Bank Account Number">
                            <Input
                                type="number"
                                name="bankAccountNumber"
                                value={formData.bankAccountNumber}
                                onChange={handleChange}
                                placeholder="Account number"
                            />
                        </Field>

                        {/* Bank Account Holder Name */}
                        <Field label="Bank Account Holder Name">
                            <Input
                                name="bankAccountName"
                                value={formData.bankAccountName}
                                onChange={handleChange}
                                placeholder="Account holder name"
                            />
                        </Field>

                        {/* Bank Name */}
                        <Field label="Bank Name">
                            <Input
                                name="bankName"
                                value={formData.bankName}
                                onChange={handleChange}
                                placeholder="Bank name"
                            />
                        </Field>

                        {/* Bank Branch */}
                        <Field label="Bank Branch">
                            <Input
                                name="bankBranch"
                                value={formData.bankBranch}
                                onChange={handleChange}
                                placeholder="Branch name"
                            />
                        </Field>

                        {/* IFSC Code */}
                        <Field label="IFSC Code">
                            <Input
                                name="ifscCode"
                                value={formData.ifscCode}
                                onChange={handleChange}
                                placeholder="IFSC0000000"
                            />
                        </Field>
                    </FieldGrid>
                </SectionCard>

                {/* 6. Documents */}
                <SectionCard icon={<IoDocumentTextOutline />} title="Documents & Signature">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                        <FileUpload
                            key={`Stamp-${resetKey}`}
                            label="Stamp"
                            icon={<LiaStampSolid />}
                            id="stamp-upload"
                            required
                            onChange={(e) =>
                                handleFileUpload(
                                    e,
                                    "doctorStamp",
                                    "doctorStampType"
                                )
                            }
                        />
                        <FileUpload
                            key={`Signature-${resetKey}`}
                            label="Doctor's e-Signature"
                            icon={<LiaSignatureSolid />}
                            id="sig-upload"
                            required
                            onChange={(e) =>
                                handleFileUpload(
                                    e,
                                    "doctorSignature",
                                    "doctorSignatureType"
                                )
                            }
                        />
                    </div>
                </SectionCard>
                {/* 7. Fees */}
                <SectionCard icon={<IoPricetagsOutline />} title="Consultation Fees & Availability">
                    <FieldGrid cols={3}>
                        <ConsultationSchedule
                            label="In-person Consultation"
                            type="inPerson"
                            consultationData={consultationData}
                            setConsultationData={setConsultationData}
                        />
                        <ConsultationSchedule
                            label="Video Consultation"
                            type="video"
                            consultationData={consultationData}
                            setConsultationData={setConsultationData}
                        />
                        <ConsultationSchedule
                            label="Home Visit Consultation"
                            type="homeVisit"
                            consultationData={consultationData}
                            setConsultationData={setConsultationData}
                        />
                    </FieldGrid>
                </SectionCard>

                {/* 8. Settings */}
                <SectionCard icon={<MdSettings />} title="Settings & Visibility">
                    <div className="-mx-6 -mb-6">
                        <Toggle
                            label="Display in Website"
                            description="Show doctor profile on Doxzon website"
                            checked={toggles.displayWebsite}
                            onChange={handleWebsiteAndSlotsToggle}
                        />
                        <Toggle
                            label="Publish Slots"
                            description="Allow patients to book appointment slots"
                            checked={toggles.publishSlots}
                            onChange={handleWebsiteAndSlotsToggle}
                        />
                        <Toggle
                            label="HIMS (IPD) Applicable"
                            description="Enable HIMS (IPD) functionality for this doctor"
                            checked={toggles.himsApplicable}
                            onChange={handleHimsToggle}
                        />

                    </div>
                </SectionCard>

                {/* Footer Buttons */}
                <div className="flex justify-end gap-3 pt-2">
                    <button
                        type="reset"
                        className="px-6 py-2.5 rounded-xl border border-slate-200 bg-white text-slate-600 text-sm font-semibold hover:border-slate-400 hover:text-slate-800 transition"
                    >
                        Reset
                    </button>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`px-8 py-2.5 rounded-xl text-white text-sm font-semibold shadow-md transition-all
                            ${isSubmitting
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-gradient-to-r from-blue-800 to-blue-500 hover:opacity-90 hover:-translate-y-0.5"
                            }`}
                    >
                        {isSubmitting ? "Submitting..." : "Submit Enrollment"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default DoctorEnrollmentForm;